/* eslint-env browser */
import * as React from 'react'

import { subscribe, unsubscribe } from '../services/pub-sub'

const ReactDOM = require('react-dom')
const PropTypes = require('prop-types')
const DomHelper = require('../dom-helper')

const PecheurComLink = require('../../../client/clientjs/components/Ads/PecheurComLink.jsx')

class PecheurComLinkContainer extends React.Component {
  constructor(props) {
    super(props)
    const { product } = props
    this.state = {
      product,
    }
  }

  componentDidMount() {
    this._subId = subscribe('updatePecheurComProduct', ({ args: { model } }) => {
      this.setState({ product: model })
    })
  }

  componentWillUnmount() {
    unsubscribe('updatePecheurComProduct', this._subId)
  }

  render() {
    const { product } = this.state
    if (!product || (product.articles || []).length === 0 || !product.articles[0].supplierData) {
      return <div />
    }
    const { locale } = this.props
    return <PecheurComLink product={product} locale={locale} />
  }
}
PecheurComLinkContainer.propTypes = {
  product: PropTypes.object,
  locale: PropTypes.string.isRequired,
}
PecheurComLinkContainer.defaultProps = {
  product: null,
}

// eslint-disable-next-line react/no-multi-comp
const DecathlonLinkContainer = props => {
  const { decathlonAffiliations } = props
  if ((decathlonAffiliations || []).length === 0) {
    return <div />
  }
  /**
   * [{
    "page": "https://click.linksynergy.com/link?id=4QXXa83rQzE&offerid=809473.15485291928&type=15&murl=https%3A%2F%2Fwww.decathlon.fr%2Fp%2Famorce-gooster-special-tous-poissons-feeder-4-75kg%2F_%2FR-p-327298%3Fmc%3D8600414%26LGWCODE%3D4103202%3B165817%3B9565", 
    "pixel": "https://ad.linksynergy.com/fs-bin/show?id=4QXXa83rQzE&bids=809473.15485291928&type=15&subid=0", 
    "price": {"amount": 9.4, "currency": "EUR"}, 
    "displayName": "AMORCE GOOSTER SPECIAL TOUS POISSONS FEEDER 4,75kg - Caperlan"
   */
  return (
    <div>
      {decathlonAffiliations.map(elt => (
        <div key={elt.displayName} className="card has-margin-bottom-small has-margin-top-small">
          <div className="columns is-mobile is-multiline">
            <div className="column is-12 has-padding-bottom-zero">
              <img src={elt.pixel} alt="" />
              <a target="_blank" rel="noopener noreferrer" className="has-text-centered" href={elt.page}>
                <img
                  src="https://statics.fishfriender.com/statics/partners/caperlan_one%20typo.png"
                  target="_blank"
                  alt="Pecheur.com"
                  className="img-responsive"
                  style={{ width: '100%', paddingLeft: 10, paddingRight: 10 }}
                />
              </a>
            </div>
            <div className="column is-12 has-padding-top-zero">
              <a target="_blank" rel="noopener noreferrer" className="has-text-centered" href={elt.page}>
                <div className="title has-text-weight-bold" style={{ color: '#4a4a4a', fontSize: 17 }}>
                  {elt.price.amount} €
                </div>
                <div className="subtitle has-text-centered" style={{ fontSize: 13 }}>
                  {elt.displayName}
                </div>
              </a>
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}
DecathlonLinkContainer.propTypes = {
  decathlonAffiliations: PropTypes.array,
}
DecathlonLinkContainer.defaultProps = {
  decathlonAffiliations: [],
}

module.exports = () => {
  const containerElt = DomHelper.queryAll('.pecheur-com-link')
  if (containerElt && containerElt.length > 0) {
    containerElt.forEach(container => {
      ReactDOM.render(
        <PecheurComLinkContainer
          product={window.initialState.initialAdProductPecheur}
          locale={window.initialState.locale.identifierShort}
        />,
        container
      )
    })
  }

  const decathlonContainerElt = DomHelper.queryAll('.decathlon-link')
  if (decathlonContainerElt && decathlonContainerElt.length > 0) {
    decathlonContainerElt.forEach(container => {
      ReactDOM.render(
        <DecathlonLinkContainer decathlonAffiliations={window.initialState.decathlonSuplierDatas} />,
        container
      )
    })
  }
}
